import * as yup from 'yup'
import { InferType } from 'yup'

import { TTranslationFunction } from '@/types'

import { urlSchema } from '../fieldSchemas'

export const FACEBOOK_BUTTON_TITLE_MAX_LENGTH = 50

export const getFacebookInfoFormSchema = (t: TTranslationFunction) =>
	yup
		.object({
			url: urlSchema(t, { required: true }),
			name: yup
				.string()
				.notRequired()
				.max(
					100,
					t('ui__field_validation_errors__generic__max_length', {
						length: 100,
					}),
				),
			title: yup
				.string()
				.max(
					50,
					t('ui__field_validation_errors__generic__max_length', {
						length: 50,
					}),
				)
				.required(t('ui__field_validation_errors__generic__required')),
			website: urlSchema(t, { required: false }),
			buttons: yup
				.array(
					yup.object({
						title: yup
							.string()
							.required(t('ui__field_validation_errors__generic__required'))
							.max(
								FACEBOOK_BUTTON_TITLE_MAX_LENGTH,
								t('ui__field_validation_errors__generic__max_length', {
									length: FACEBOOK_BUTTON_TITLE_MAX_LENGTH,
								}),
							),
						url: urlSchema(t, { required: true }),
					}),
				)
				.required(),
		})
		.required()

export type TFacebookInfoFields = InferType<
	ReturnType<typeof getFacebookInfoFormSchema>
>

export type TFacebookButton = TFacebookInfoFields['buttons'][number]
